import { formatDateForInput } from '@/utils/formatters';

// Local, not UTC: toISOString() still reads yesterday just after midnight in Europe.
export function getTodayAsISODate(): string {
  return formatDateForInput(new Date());
}

/**
 * Leniently parses a typed day-month-year string into an ISO date (YYYY-MM-DD).
 * Accepts `-`, `/` or `.` separators and single-digit day/month (e.g. `6-7-2026`),
 * but requires a 4-digit year. Returns null for malformed input or calendar-invalid
 * dates such as 31-02-2026. Uses UTC throughout to avoid timezone day shifts.
 */
export function parseDateInput(text: string): string | null {
  const match = text.trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);

  const date = new Date(Date.UTC(year, month - 1, day));
  const isRealCalendarDate =
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day;
  if (!isRealCalendarDate) return null;

  return date.toISOString().slice(0, 10);
}

/**
 * Adds a number of years to a date string (YYYY-MM-DD), returning a new date string.
 * Uses UTC methods throughout to avoid timezone-related day shifts.
 */
export function addYearsToDate(dateStr: string, years: number): string {
  const date = new Date(dateStr);
  date.setUTCFullYear(date.getUTCFullYear() + years);
  return date.toISOString().slice(0, 10);
}
